import navMain from './navMain'
import heroMain from './heroMain'
import mePegasusMain from './mePegasusMain'
import goalMain from './goalMain'
import systemMain from './systemMain'
import developMain from './developMain'
import faqMain from './faqMain'
import formSection from './formSection'
import footer from './footer'
import heroAboutPegasus from './heroAboutPegasus'
import oursAboutPegasus from './oursAboutPegasus'
import ecosystemAboutPegasus from './ecosystemAboutPegasus'
import systems from './systems'
import career from './career'
import contacts from './contacts'
import terms from './terms'
import privacy from './privacy'
import blog from './blog'
const uk = {
  navMain,
  heroMain,
  mePegasusMain,
  goalMain,
  footer,
  faqMain,
  systemMain,
  developMain,
  formSection,
  heroAboutPegasus,
  oursAboutPegasus,
  ecosystemAboutPegasus,
  systems,
  career,
  contacts,
  terms,
  privacy,
  blog,
}

export default uk
